import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class CrmInteractionService extends Service {
	constructor(injector: Injector) {
		super("CrmInteraction", injector);
	}

	getByClientId(clientId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByClientId/${clientId}`);
	}

	getByContactId(contactId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByContactId/${contactId}`);
	}

	getByEventId(eventId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByEventId/${eventId}`);
	}

	getByLeadId(leadId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByLeadId/${leadId}`);
	}

	getMyRecentInteractions() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetMyRecentInteractions`);
	}

	getUpcomingFollowUps() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetUpcomingFollowUps`);
	}
}
